import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useState } from "react";
import styled, { css } from "styled-components";
export var SeoTextBlock = function(param) {
    var header = param.header, content = param.content;
    var isMobile = useViewport().isMobile;
    var _useState = _sliced_to_array(useState(false), 2), hideShowMoreButton = _useState[0], setHideShowMoreButton = _useState[1];
    var renderShowMoreButton = function() {
        if (!hideShowMoreButton && isMobile) {
            return /*#__PURE__*/ _jsx(ShowMoreButton, {
                onClick: function() {
                    return setHideShowMoreButton(true);
                },
                "data-test-id": "show-more-button",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "bMeAx2",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Show all"
                        }
                    ]
                })
            });
        }
        return null;
    };
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: header
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 8
            }),
            /*#__PURE__*/ _jsxs(Content, {
                color: Core.text.subdued,
                $showMore: hideShowMoreButton,
                children: [
                    content,
                    renderShowMoreButton()
                ]
            })
        ]
    });
};
SeoTextBlock.displayName = "SeoTextBlock";
var Wrapper = styled.div.withConfig({
    componentId: "sc-b5af0040-0"
})([
    "position:relative;"
]);
var Content = styled(Typography).withConfig({
    componentId: "sc-b5af0040-1"
})([
    "white-space:pre-line;",
    "{display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;",
    ";}"
], responsiveMediaQueries.mobile, function(props) {
    return props.$showMore ? css([
        "-webkit-line-clamp:unset;-webkit-box-orient:unset;overflow:visible;"
    ]) : "";
});
var ShowMoreButton = styled(Button).attrs({
    variant: "tertiary"
}).withConfig({
    componentId: "sc-b5af0040-2"
})([
    "",
    "{display:unset;color:",
    ";text-align:right;min-width:115px;padding:0;background:linear-gradient( 90deg,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 30% );position:absolute;bottom:0;right:0;}"
], responsiveMediaQueries.mobile, Core.text.subdued);
